import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=b13611fc&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=ts&"
export * from "./Comment.vue?vue&type=script&lang=ts&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=b13611fc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13611fc",
  null
  
)

export default component.exports